// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { LazyImageStyle } from "@awc/MobiusOverrides/LazyImage";
import { logoStyles } from "@awc/Overrides/Widgets/Basic/Logo";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        max-height: 68px;
        max-width: none;
        ${xScreen("lte", "sm")} {
            max-height: 48px;
            ${LazyImageStyle} {
                picture {
                    width: 100%;
                }
            }
        }
    `,
};
